export var Layout;
(function (Layout) {
    Layout["Vertical"] = "vertical";
    Layout["Horizontal"] = "horizontal";
})(Layout || (Layout = {}));
//# sourceMappingURL=IContainer.js.map